import { BubbleFormPage } from '@go-client/components/BubbleUI/BubbleForm';
import { ReservationWorkflowPrereqs, ResPathDataBundle } from '../ReservationPath';
import React from 'react';
import EnterReservationPage from '../Pages/EnterReservationPage';
import { NewReservation } from '@go-shared/types/reservation';
import { update } from '@go-client/lib/api/reservation';

export default function buildEditReservationWorkflow(
  pages: Array<BubbleFormPage<ResPathDataBundle>>,
  preqs: ReservationWorkflowPrereqs
) {
  async function handleSubmitReservationForm() {
    preqs.setIsBusy(true);
    try {
      if (!preqs.mode.edit) {
        throw new Error('No reservation to edit found in edit mode');
      }

      const newRes = (await preqs.formik.submitForm()) as unknown as NewReservation;
      if (!newRes) {
        throw new Error('No reservation data to submit');
      }

      const toSubmit = {
        ...preqs.mode.edit,
        ...newRes,
        _id: preqs.mode.edit._id,
      };

      const newSchedule = await update(toSubmit);

      preqs.onRefreshReservation?.(newSchedule);
    } finally {
      preqs.setIsBusy(false);
    }
  }

  const editTitle = `Edit Reservation - ${preqs.mode.edit?.reservationCode ?? ''}`;

  pages.push({
    key: 'edit-page-1',
    render: (_, res) =>
      res &&
      preqs.selectedEventSnapshot && (
        <EnterReservationPage
          formik={preqs.formik}
          title={editTitle}
          forwardTitle="Finish: Edit Reservation"
          mode={preqs.mode}
          users={res.users}
          isBusy={preqs.isBusy}
          setIsBusy={preqs.setIsBusy}
          selectedEventSnapshot={preqs.selectedEventSnapshot}
          onClose={preqs.onClose}
          onSubmitReservationForm={handleSubmitReservationForm}
          onRefreshReservation={preqs.onRefreshReservation}
          onNavigateToReservation={preqs.onNavigateToReservation}
        />
      ),
  });
}
